import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class StrippingApi {
  getStrippingProcessListApi(payload) {
    return api.post(API_URLS.URL.stripping.processList, payload);
  }

  addNewStrippingApi(payload) {
    return api.post(API_URLS.URL.stripping.createProcess, payload || {});
  }

  getStrippingProcessByIdApi(processId) {
    return api.get(
      API_URLS.URL.stripping.processById?.replace(":id", processId),
    );
  }

  updateStrippingProcessByIdApi(processId, payload) {
    return api.put(
      API_URLS.URL.stripping.processById?.replace(":id", processId),
      payload,
    );
  }

  getStrippingProcessDataApi(payload) {
    return api.post(API_URLS.URL.stripping.processData, payload);
  }

  updateStrippingProcessDataByIdApi(processId, payload) {
    return api.put(
      API_URLS.URL.stripping.processDataById?.replace(":id", processId),
      payload,
    );
  }

  getProcessDataById(processId) {
    return api.get(
      API_URLS.URL.stripping.getProcessDataById?.replace(":id", processId),
    );
  }

  addStrippingProcessDataApi(payload) {
    return api.post(API_URLS.URL.stripping.addProcessData, payload);
  }

  sendToStrippingProcessApi(payload) {
    return api.post(API_URLS.URL.stripping.sendToStrippingProcess, payload);
  }

  addWasteWaterData(payload) {
    return api.post(API_URLS.URL.stripping.addWasteWaterData, payload);
  }

  updateWasteWater(wasteWaterId, payload) {
    return api.put(
      API_URLS.URL.stripping.updateWasteWater?.replace(":id", wasteWaterId),
      payload,
    );
  }

  getWasteWaterList(payload) {
    return api.post(API_URLS.URL.stripping.getWasteWaterList, payload);
  }

  addStrippingSubLogData(payload) {
    return api.post(API_URLS.URL.stripping.addStrippingSubLogData, payload);
  }

  updateStrippingSubLog(subLogId, payload) {
    return api.put(
      API_URLS.URL.stripping.updateStrippingSubLog?.replace(":id", subLogId),
      payload,
    );
  }

  deleteStrippingSubLog(subLogId) {
    return api.delete(
      API_URLS.URL.stripping.deleteStrippingSubLog?.replace(":id", subLogId),
    );
  }

  getStrippingSubLogList(payload) {
    return api.post(API_URLS.URL.stripping.getStrippingSubLogList, payload);
  }
}
